<script setup lang="ts">
import { computed } from 'vue'
import type { VariantProps } from 'tailwind-variants'
import { cn } from '@/lib/cn'
import { buttonVariants } from './button-variants'
import Spinner from './Spinner.vue'

type BV = VariantProps<typeof buttonVariants>

const props = withDefaults(
  defineProps<{
    variant?: BV['variant']
    size?: BV['size']
    class?: string
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
    loading?: boolean
  }>(),
  {
    variant: 'primary',
    size: 'md',
    type: 'button',
    disabled: false,
    loading: false,
  },
)

const isDisabled = computed(() => props.disabled || props.loading)

const spinnerClass = computed(() => {
  if (props.size === 'sm') return 'h-3.5 w-3.5 border-t-current'
  if (props.size === 'lg') return 'h-5 w-5 border-t-current'
  return 'h-4 w-4 border-t-current'
})

const cls = computed(() => cn(buttonVariants({ variant: props.variant, size: props.size }), props.class))
</script>

<template>
  <button
    :type="type"
    :disabled="isDisabled"
    :aria-busy="loading || undefined"
    :class="cls"
  >
    <Spinner v-if="loading" :class="spinnerClass" />
    <slot />
  </button>
</template>
